import {gsap} from "gsap";

const animationLeaveForSingleProject = (container) => {
    // console.log("Projects animation LEAVE for project");


    const projects_li = container.querySelectorAll("#projects-list li");
    const tl = gsap.timeline({
        defaults : {
            duration: .5,
            ease: "power1.out",
        },
        delay:0
    });
    // si le menu de navigation mobile est ouvert, je dois le refermer avant de lancer l'animation
    // de fadeout.
    const body_el = document.body;
    const classMenuOpened = "mobile-nav-opened";
    var delay_leave = '0';
    if(body_el.classList.contains(classMenuOpened)){
        const toggle_mobile_nav_button_el = document.querySelector("#burger-menu");
        // Create our event (with options)
        var evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        toggle_mobile_nav_button_el.dispatchEvent(evt);
        delay_leave = ".3";
    }

    tl.to(projects_li, {alpha:0,delay:delay_leave, duration:.5,ease: "power1.inout",stagger: { // wrap advanced options in an object
            amount: 0.15,
            from: "center",
            ease: "power2.inOut",
        }});
    tl.to("#scrollToContentLink", {duration:.3,alpha:0, y:-100, ease:"power1.out"}, '-=.3')
    tl.to("#pre-footer", {duration:.3,alpha:0, y:0, ease:"power1.out"}, '-=.3')
    //tl.to(container, {alpha:0})
    return tl;
}

export default animationLeaveForSingleProject;
